import React from 'react';

function PremiumIcon({ className = "h-5 w-5" }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M4.5 18.5h15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M5.2 16.5L4 7.2l5.2 3.6L12 4.5l2.8 6.3L20 7.2l-1.2 9.3H5.2Z"
        fill="currentColor"
      />
      <circle cx="12" cy="13" r="1.2" fill="white" />
    </svg>
  );
}

function PremiumButton({ className = '', onClick }) {
  return (
    <a
      href="/premium"
      onClick={onClick}
      className={`no-underline inline-flex items-center gap-2 rounded-full bg-orange-50 px-4 py-2 text-base font-semibold text-orange-600 transition hover:bg-orange-100 hover:text-orange-700 ${className}`}
    >
      <PremiumIcon className="h-5 w-5" />
      <span>Premium</span>
    </a>
  );
}

function BigPremiumButton({ className = '', onClick }) {
  return (
    <a
      href="/premium"
      onClick={onClick}
      className={`no-underline inline-flex items-center justify-center gap-3 rounded-full bg-blue-600 px-12 py-3 text-xl font-bold text-white shadow-lg shadow-blue-200 transition hover:bg-blue-700 ${className}`}
    >
      <PremiumIcon className="h-6 w-6" />
      <span>Premium</span>
    </a>
  );
}

export { PremiumIcon, PremiumButton, BigPremiumButton };